import React, { useState, useEffect } from 'react'
import { useGeneralApp } from '../../hooks/useGeneralApp'
import { useAuth } from '../../hooks/useAuth'
import { LoginPage } from '../../pages/Login'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

export const LoggedGuard = () => {
  const { isLoading } = useGeneralApp()
  const auth = useAuth()
  const location = useLocation()
  const [requestedLocation, setRequestedLocation] = useState(null)
  useEffect(() => {}, [isLoading])
  // if user is not authenticated redirect to login
  if (!auth.isAuthenticated) {
    if (isLoading === false) {
      if (location.pathname !== requestedLocation) {
        setRequestedLocation(location.pathname)
      }
      return <LoginPage />
    }
  }
  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null)
    return <Navigate to={requestedLocation} />
  }

  if (isLoading === false) {
    return <Outlet/>
  }
}
